import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutingStrategy } from '@core';
import { WorkInProgressComponent } from '@layout/work-in-progress/work-in-progress.component';
import { NotFoundComponent } from './layout/not-found/not-found.component';
import { IndexComponent } from './pages/index/index.component';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    // canActivate: [AuthGuardService],
    data: {preload: true ,public: true}
  },
  {
    path: 'cms/:id',
    loadChildren: () => import('./pages/cms/cms.module').then(m => m.CmsModule),
    // canActivate: [AuthGuardService],
    data: { preload: true, public: true }
  },
  {
    path: 'cms/:id/:page',
    loadChildren: () => import('./pages/cms/cms.module').then(m => m.CmsModule),
    // canActivate: [AuthGuardService],
    data: { preload: true, public: true }
  },
  {
    path: 'workInProgress',
    component: WorkInProgressComponent,
    // canActivate: [AuthGuardService]
  },
  {
    path: 'notFound',
    component: NotFoundComponent,
    // canActivate: [AuthGuardService],
    data: { public: true }
  },
  // changed this path
  {
    path: 'PIC',
    pathMatch: 'full',
    component: IndexComponent,
    data: { public: true }
  },
  {
    path: 'GO26',
    pathMatch: 'full',
    component: IndexComponent,
    data: { public: true }
  },
  {
    path: '**',
    // pathMatch: 'full',
    component: IndexComponent,
    data: { public: true }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    enableTracing: true,
    preloadingStrategy: RoutingStrategy,
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule],
  providers: [RoutingStrategy]
})
export class AppRoutingModule { }
